module.exports = __webpack_public_path__ + "img/more.b051fce7.png";